import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';
import StaticFunctions from "./StaticFunctions";

class ParentCompanySelector extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        selectedCompany: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        name: 'id_parent',
        clearable: false
    };

    constructor(props) {

        super(props);

        this.state = {
            value: (props.selectedCompany) ? props.selectedCompany.id_parent : null
        };

        this.translate = this.props.baseData.translate;

        this.onChange = this.onChange.bind(this);

    }

    onChange(event) {

        if (!event) return null;

        if (this.props.onChange) this.props.onChange(this.props.name, event);

        this.setState({
            value: event.value
        });

    }

    getSelectedCompany() {

        if (!this.props.selectedCompany) return [];

        const selectedCompanyId = this.props.selectedCompany.id;
        const companies = this.props.baseData.companies.companies;

        return StaticFunctions.findObjectInArray(companies, 'id', selectedCompanyId);

    }

    getOptions() {

        if (!this.props.selectedCompany) return [];

        const selectedCompany = this.getSelectedCompany();
        const companies = StaticFunctions.getSortedData(this.props.baseData.companies.companies, 'name');
        const options = [];

        if (!selectedCompany) return [];

        companies.forEach(
            (company) => {
                /*if ((parseInt(company.id) === parseInt(selectedCompany.id_root) && parseInt(company.id) !== parseInt(selectedCompany.id)) ||
                    (parseInt(company.id_parent) === parseInt(selectedCompany.id_root) && parseInt(company.id_root) === parseInt(selectedCompany.id_root))) {*/
                if ((parseInt(company.id) === parseInt(selectedCompany.id_root)) ||
                    (parseInt(company.id) !== parseInt(selectedCompany.id) && parseInt(company.id_parent) === parseInt(selectedCompany.id_root) && parseInt(company.id_root) === parseInt(selectedCompany.id_root))) {
                    options.push({
                        label: company['name'],
                        value: company['id']
                    });
                }
            }
        );

        return options;

    }

    render() {
        const options = this.getOptions();
        const selectedOption = options.find(o => String(o.value) === String(this.state.value)) || null;

        return (
            <Select
                name={this.props.name}
                className="chosen-container chosen-container-single"
                style={{width: '260px'}}
                options={options}
                onChange={this.onChange}
                value={selectedOption}
                placeholder={this.translate('select') + '...'}
                clearable={this.props.clearable}
                noResultsText={this.translate('noResultsFound')}
            />
        );
    }

}

export default ParentCompanySelector;